import React from 'react'
import { Drawer, makeStyles } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import cx from 'classnames'

import useViewportSizes from '~/components/useViewportSize'

const useStyles = makeStyles((theme) => ({
  paper: {
    width: theme.gofind.asideWidth,
    height: '100%',
    position: 'absolute',
    margin: 0,
    borderRadius: 0,
    overflowX: 'hidden',
    ...theme.gofind.scrollBar
  },
  withMobile: { width: '100%', flexShrink: 0 }
}))

const CustomDrawer = ({ children, open, id }) => {
  const theme = useTheme()
  const viewport = useViewportSizes()
  const classes = useStyles()
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  return (
    <Drawer
      hideBackdrop
      anchor="left"
      id={id}
      open={open}
      classes={{
        paper: cx(classes.paper, { [classes.withMobile]: isMobile })
      }}
      ModalProps={{
        container: document.getElementById('gofind-finder') || document.body,
        style: { position: 'absolute', width: isMobile ? '100%' : theme.gofind.asideWidth }
      }}
    >
      {children}
    </Drawer>
  )
}

export default CustomDrawer
